import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import swal from "sweetalert";
import { graphqlQuery } from "../../data/Axios/DynamicService";
import { getrolesquery } from "../../data/Axios/queries";
import {
  companyManagementUrl,
  roleManagemenUrl,
  userManagementUrl,
} from "../../config";
import DynamicForm from "../../data/Axios/DynamicForm";
import { PerfomanceFields } from "../../data/DynamicTable/usersDynamicForms";
import Swal from "sweetalert2";
import {
  executeAnyMutation,
  fetchJson,
  fetchJsonDynamic,
} from "../../data/DynamicServiceNew/jsondynamicservice";

const base_url = roleManagemenUrl.uri;
const setup_url = companyManagementUrl.uri;

const PerformanceForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const tokenRegionId = parseInt(decodedToken.RegionId);
  const tokenBranchId = parseInt(decodedToken.BranchId);
  const [roleData, setRoleData] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false); // Changed variable name to camelCase
  const [showRegions, setShowRegions] = useState(false);
  const [showBranches, setShowBranches] = useState(false);
  const [genderData, setGenderData] = useState([]);
  const [branchOptionsInitialValue, setBranchOptionsInitialValue] = useState(
    []
  );
  const [branchIdData, setBranchIdData] = useState(null);
  const [regionIdData, setRegionIdData] = useState(null);
  const [showRegionsOnly, setShowRegionsOnly] = useState(false);
  const [selectedRegionId, setSelectedRegionId] = useState([]);
  const [mappedBranches, setMappedBranches] = useState([]);

  const formatDateForDisplay = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) {
      console.error("Invalid timestamp:", timestamp);
      return "";
    }
    return date.toISOString().split("T")[0];
  };

  // Move setIsEditing logic to useEffect
  useEffect(() => {
    if (Array.isArray(props.userData) && props.userData[0]?.Enddate) {
      const today = new Date();
      const endDate = new Date(props.userData[0].Enddate);
      setIsEditing(
        !isNaN(endDate.getTime()) && endDate <= today ? false : true
      );
    } else {
      setIsEditing(false); // Default to true if no valid Enddate
    }
  }, [props.userData]);

  const initialValues =
    isEditing && props.userData.length > 0
      ? {
          collectionrate: props.userData
            ? props.userData[0].Collectionrate
            : "",
          par: props.userData ? props.userData[0].Par : "",
          LoanCount: props.userData ? props.userData[0].Loancount : "",
          loanamount: props.userData ? props.userData[0].Loanamount : "",
          CustomerRetention: props.userData
            ? props.userData[0].Customerretention
            : "",
          LogbookLoans: props.userData ? props.userData[0].Logbookloans : "",
          checkoffloans: props.userData ? props.userData[0].CheckoffLoans : "",
          revenueperrep: props.userData ? props.userData[0].Returnperro : "",
          churnrate: props.userData ? props.userData[0].Customerchurnrate : "",
          clv: props.userData ? props.userData[0].Customerlifetimevalue : "",
          rpr: props.userData ? props.userData[0].RepeatPurchaseRate : "",
          StartDate: props.userData
            ? formatDateForDisplay(props.userData[0].StartDAte)
            : "",
          EndDate: props.userData
            ? formatDateForDisplay(props.userData[0].Enddate)
            : "",
        }
      : {
          collectionrate: null,
          par: null,
          LoanCount: null,
          loanamount: null,
          CustomerRetention: null,
          LogbookLoans: null,
          revenueperrep: null,
          churnrate: null,
          clv: null,
          rpr: null,
          StartDate: null,
          EndDate: null,
          checkoffloans: null,
        };

  useEffect(() => {
    async function fetchAllData() {
      try {
        const facts = await graphqlQuery(getrolesquery, base_url);
        if (facts) {
          setRoleData(facts);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchAllData();
  }, []);

  useEffect(() => {
    async function fetchAllData() {
      try {
        const regionResponse = await fetchJson({
          objectName: "region",
          baseUrl: companyManagementUrl.uri,
        });
        const allRegions = JSON.parse(regionResponse.results) || [];
        if (allRegions) {
          setRegionData(allRegions || []);
        }

        if (tokenRegionId) {
          const branchResponse = await fetchBranches(tokenRegionId);
          setBranchData(branchResponse || []);
        }

        if (props.userData && props.userData.roleId) {
          handleRoleChange(props.userData.roleId);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchAllData();
  }, [props.userData]);

  const handleFieldChange = async (field, value) => {
    if (field.name === "roleId") {
      handleRoleChange(value);
      setSelectedRegionId(value);
    }
    if (field.name === "regionId") {
      console.log("Selected Region ID:", value);
      const branchOptions = await fetchBranches(value);
      console.log("Fetched Branch Options:", branchOptions);
      setBranchOptionsInitialValue(branchOptions || []);
      setBranchData(branchOptions);
      console.log("Branch Options:", branchOptions);
      setBranchIdData(null);
      return branchOptions;
    }
  };

  const fetchBranches = async (regionId) => {
    try {
      console.log("Fetching branches for regionId:", regionId);
      const params = { regionId: parseInt(regionId) };
      console.log("Params for API call:", params);

      const businessDetails = await fetchJsonDynamic(
        "allBranchesByColumnValues",
        "branchModel",
        params,
        setup_url
      );

      console.log("API Response:", businessDetails);

      const allBranchDetails = JSON.parse(businessDetails.results) || [];
      console.log("Parsed branch details:", allBranchDetails);

      const branchOptions = allBranchDetails.map((role) => ({
        parent_key: role.Id,
        value: role.Id,
        label: role.Name,
      }));

      console.log("Mapped Branch Options:", branchOptions);
      setMappedBranches(branchOptions);

      return branchOptions;
    } catch (error) {
      console.error("Error fetching branches:", error);
      return [];
    }
  };

  const handleRoleChange = (roleId) => {
    const selectedRole = roleData.find((role) => role.id === parseInt(roleId));
    if (selectedRole) {
      const { roleGroupId } = selectedRole;
      const tokenRoleGroupId = parseInt(decodedToken.RoleGroupId);
      if (tokenRoleGroupId === 1 || tokenRoleGroupId === 2) {
        if (roleGroupId === 1 || roleGroupId === 2) {
          setShowRegions(false);
          setShowBranches(false);
          setShowRegionsOnly(false);
        } else if (roleGroupId === 3) {
          setShowRegionsOnly(true);
          setShowRegions(false);
          setShowBranches(false);
        } else if (roleGroupId === 4 || roleGroupId === 5) {
          setShowRegions(true);
          setShowBranches(false);
          setShowRegionsOnly(false);
        }
      } else if (tokenRoleGroupId === 3) {
        if (roleGroupId === 3) {
          setShowRegionsOnly(false);
          setShowRegions(false);
          setShowBranches(false);
          setRegionIdData(tokenRegionId);
        } else if (roleGroupId === 4 || roleGroupId === 5) {
          setShowRegions(false);
          setShowBranches(true);
          setShowRegionsOnly(false);
          setRegionIdData(tokenRegionId);
        }
      } else {
        if (roleGroupId === 4 || roleGroupId === 5) {
          setShowRegions(false);
          setShowBranches(false);
          setShowRegionsOnly(false);
          setBranchIdData(tokenBranchId);
          setRegionIdData(tokenRegionId);
        }
      }
    }
  };

  const roleOptions = roleData
    ? roleData.map((role) => ({
        parent_key: role.id,
        value: role.id,
        label: role.role,
      }))
    : [];
  const regionOptions = regionData
    ? regionData.map((role) => ({
        parent_key: role.Id,
        value: role.Id,
        label: role.Name,
      }))
    : [];

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const storedUserData = localStorage.getItem("userToEdit");
      const {
        collectionrate,
        CustomerRetention,
        loanamount,
        LoanCount,
        LogbookLoans,
        par,
        checkoffloans,
        churnrate,
        clv,
        revenueperrep,
        StartDate,
        EndDate,
        rpr,
      } = values;

      const mutationData = {
        fieldOfficerId:
          props.userData.length > 0 &&
          props.userData[0].FieldOfficerId &&
          props.isEditing
            ? parseInt(props.userData[0].FieldOfficerId)
            : parseInt(storedUserData),
        collectionrate: parseFloat(collectionrate),
        customerretention:
          CustomerRetention === null ? null : parseFloat(CustomerRetention),
        loanamount: loanamount === null ? null : parseFloat(loanamount),
        customerlifetimevalue: clv === null ? null : parseFloat(clv),
        returnperro: revenueperrep === null ? null : parseFloat(revenueperrep),
        customerchurnrate:
          churnrate === null || churnrate === "" ? null : parseFloat(churnrate),
        loancount: LoanCount,
        logbookloans:
          LogbookLoans == null || LogbookLoans === ""
            ? null
            : parseFloat(LogbookLoans),
        checkoffLoans:
          checkoffloans === null || checkoffloans === ""
            ? null
            : parseInt(checkoffloans),
        par: par === null ? null : parseFloat(par),
        repeatPurchaseRate: rpr === null || rpr === "" ? null : parseFloat(rpr),
        startDAte: StartDate,
        enddate: EndDate,
      };

      if (isEditing) {
        mutationData.id = props.userData[0].Id;
      }

      const response = await executeAnyMutation(
        isEditing ? "updatePerfomanceTarget" : "createPerfomanceTarget",
        mutationData,
        "perform",
        false,
        userManagementUrl.uri
      );

      if (response.results) {
        props.onClose();
        props.refetch();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `User Target ${
            isEditing ? "updated" : "created"
          } successfully.`,
        });
      } else if (response.error) {
        const errorObj = JSON.parse(response.error);
        const errorMessage = errorObj?.Error?.match(
          /System\.Exception: (.*?)\./
        )?.[1];
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Please contact the Admin.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  const fields = [...PerfomanceFields];

  return (
    <div>
      <DynamicForm
        initialValues={initialValues}
        fields={fields}
        onFieldChange={handleFieldChange}
        onSubmit={handleSubmit}
        title={isEditing ? "Edit RO Target" : "Create RO Target"}
        subtitle={
          isEditing ? "Edit an Existing Target" : "Create a New RO Target"
        }
      />
    </div>
  );
};

export default PerformanceForm;
